export default function () {
  const { $ } = window as any
  $('.week_list').stickyTableHeaders()
}
